// スピーカーテストの TTS 失敗時 fallback (spec D4): WebAudio 固定トーン (vendor 非依存)。
export type TestToneHandle = { stop: () => void };
type SinkCapableAudioContext = AudioContext & { setSinkId?: (id: string) => Promise<void> };

export function startTestTone(sinkId?: string): TestToneHandle {
  const ctx = new AudioContext() as SinkCapableAudioContext;
  if (sinkId && typeof ctx.setSinkId === "function") {
    void ctx.setSinkId(sinkId).catch(() => undefined);
  }
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.frequency.value = 440;
  gain.gain.value = 0.1; // 突然の大音量を避ける
  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start();

  let stopped = false;
  return {
    stop: () => {
      if (stopped) return;
      stopped = true;
      oscillator.stop();
      void ctx.close().catch(() => undefined);
    },
  };
}
